import React, { useEffect, useState } from 'react';
import FootNote from './FootNote';

const FootNotesManager = () => {
  const [notes, setNotes] = useState([])

  useEffect(() => {
    const elements = Array.from(document.getElementsByClassName("footnote"))

    const notes = elements.map((e) => {
      return {
        id: e.id
      }
    })

    setNotes(notes)
  }, [])

  return (
    <React.Fragment>
      {notes.map((n) => {
        return <FootNote key={n.id} portalId={n.id} content="hello"></FootNote>
      })}
    </React.Fragment>
  );
};

export default FootNotesManager;